import { render } from "./TermsFooter.vue?vue&type=template&id=4529d810&scoped=true"
import script from "./TermsFooter.vue?vue&type=script&lang=js"
export * from "./TermsFooter.vue?vue&type=script&lang=js"

import "./TermsFooter.vue?vue&type=style&index=0&id=4529d810&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4529d810"]])

export default __exports__